import React from 'react'
import PropTypes from 'prop-types'
import TitleVideo from './TitleVideo'
import TitleSeriesVideo from './TitleSeriesVideo'
import TitleCourseVideo from './TitleCourseVideo'

export const TYPE = {
  VIDEO: 'VIDEO',
  SERIES: 'SERIES',
  COURSE: 'COURSE',
}

const TitleVideoLink = (props) => {
  const { type, primaryCourse } = props
  if (type === TYPE.VIDEO) {
    return <TitleVideo {...props} />
  }
  if (type === TYPE.SERIES) {
    return <TitleSeriesVideo {...props} />
  }
  if (type === TYPE.COURSE) {
    return primaryCourse ? <TitleCourseVideo {...props} /> : <TitleVideo {...props} />
  }

  return null
}

TitleVideoLink.propTypes = {
  type: PropTypes.oneOf([TYPE.VIDEO, TYPE.SERIES, TYPE.COURSE]).isRequired,
  hasHeader: PropTypes.bool.isRequired,
  linkClass: PropTypes.string,
  titleClass: PropTypes.string,
}
TitleVideoLink.defaultProps = {
  hasHeader: false,
}

export default TitleVideoLink
